import React from "react";
import "../../styles/components/CommunicationCard.scss";
import { faPlus } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const EmailLayout = (props) => {
  const { thumbNail, data, isNewLayout } = props;
  if (isNewLayout)
    return (
      <div className="newLayout">
        <div className="newOuterDiv">
          <div className="newInnerDiv">
            <div className="newCircle">
              <FontAwesomeIcon icon={faPlus} size="2x" />
            </div>
          </div>
        </div>
        <div>
          <p className="footer">New Layout</p>
        </div>
      </div>
    );
  return (
    //height 104px
    <div className="emailLayout">
      <div className="newOuterDiv">
        <img
          className="img"
          src={thumbNail}
          style={{
            // backgroundImage: `url(${thumbNail})`,
            // backgroundSize: "100% 100%",
            // position: "relative",
            height: "184px",
            width: "154px",
            borderRadius: "4px",
            marginBottom: "0",
            // right: "10px",
            // top: "5px",
          }}
        />
      </div>
      <div>
        <p className="footer">{data}</p>
      </div>
    </div>
  );
};

export default EmailLayout;
